import { EmptyComponent } from 'src/app/shared/components/empty/empty.component';
import { PrintOrderComponent } from './components/print-order/print-order.component';
import { ThesisEditOrderComponent } from './components/thesis-edit-order/thesis-edit-order.component';
import { ThesisOrderComponent } from './components/thesis-order/thesis-order.component';
import { LandingComponent } from './landing.component';
import { Route } from '@angular/router';
import { ReferralLinkResolver } from './resolvers/referral-link.resolver';

export const landingRoutes: Route[] = [
  {
    path: '',
    component: LandingComponent,
    children: [
      {
        path: '',
        // redirectTo: 'black-and-white-print',
        // pathMatch: 'full',
        component: PrintOrderComponent,
        data: {
          loc: '/',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },

      {
        path: 'black-and-white-print',
        component: PrintOrderComponent,
        data: {
          pointer: 'blackAndWhitePrint',
          reuseComponent: true,
          loc: '/black-and-white-print',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },
      {
        path: 'half-color-print',
        component: PrintOrderComponent,
        data: {
          pointer: 'halfColorPrint',
          reuseComponent: true,
          loc: '/half-color-print',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },
      {
        path: 'combined-printing',
        component: PrintOrderComponent,
        data: {
          pointer: 'mixedPrint',
          reuseComponent: true,
          loc: '/combined-printing',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },

      {
        path: 'full-color-print',
        component: PrintOrderComponent,
        data: {
          pointer: 'colorfulPrint',
          reuseComponent: true,
          loc: '/full-color-print',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },
      {
        path: 'online-print',
        component: PrintOrderComponent,
        data: {
          pointer: 'onlinePrint',
          reuseComponent: true,
          loc: '/online-print',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },
      {
        path: 'cheap-print',
        component: PrintOrderComponent,
        data: {
          pointer: 'cheapPrint',
          reuseComponent: true,
          loc: '/cheap-print',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },
      {
        path: 'booklet-print',
        component: PrintOrderComponent,
        data: {
          pointer: 'bookletPrint',
          reuseComponent: true,
          loc: '/booklet-print',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },

      {
        path: 'thesis-binding',
        component: ThesisOrderComponent,
        data: {
          animation: 'ThesisOrder',
          pointer: 'ThesisOrder',
          reuseComponent: true,
          loc: '/thesis-binding',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },

      {
        path: 'thesis-editing',
        component: ThesisEditOrderComponent,
        data: {
          pointer: 'ThesisEditOrder',
          loc: '/thesis-editing',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },

      {
        path: 'thesis/e/:id',
        component: ThesisOrderComponent,
        data: {
          editMode: true,
          pointer: 'ThesisOrder',
          loc: '/',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
          xml: true,
        },
      },

      {
        path: 'thesis-edit/e/:id',
        component: ThesisEditOrderComponent,
        data: {
          pointer: 'ThesisEditOrder',
          editMode: true,
          loc: '/',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
        },
      },

      {
        path: 'print/e/:id',
        component: EmptyComponent,
        data: {
          editMode: true,
          loc: '/',
          lastmod: '2023-09-09',
          changefreq: 'daily',
          priority: '1.0',
        },
      },

      {
        path: 'redirecting',
        component: PrintOrderComponent,
        data: {
          loc: '',
        },
      },
    ],
    resolve: {
      referral: ReferralLinkResolver,
    },
  },
];
